import makeAlertStore from './makeAlertStore';
import WindowProvider from '../window/WindowProvider';

WindowProvider.VCOM_ALERT_STORE = !WindowProvider.VCOM_ALERT_STORE
  ? makeAlertStore()
  : WindowProvider.VCOM_ALERT_STORE;

export default WindowProvider.VCOM_ALERT_STORE;
